
if (!customElements.get('car-search')){
    customElements.define(
        'car-search', class CarSearch extends HTMLElement {
            constructor(){
                super()
                this.startSearch = document.getElementById('the-search')
                this.init()
            }
            init(){
                if(this.startSearch.previousElementSibling != null){
                    if(this.startSearch.previousElementSibling.name == 'engine'){

                    }
                }
            }
        }
    )
}

if (!customElements.get('make-search')) {
    customElements.define('make-search', class MakeSearch extends HTMLElement {
        constructor(){
            super()
            this.urlPath = ''
            this.makeDone = ''
            this.yearDone = ''
            this.modelDone = ''
            this.engineDone = ''
            this.SubModelDone = ''
            this.SubModelFinal = ''

            this.make = document.querySelector('.select-make-parts')
            this.year = document.querySelector('.select-year-parts')
            this.model = document.querySelector('.select-model-parts')
            this.engine = document.querySelector('.select-engine-parts')
            this.submodel = document.querySelector('.select-sub-model-parts')

            this.make.addEventListener('change', this.getYear.bind(this))
            this.year.addEventListener('change', this.getModel.bind(this))
            this.model.addEventListener('change', this.getEng.bind(this))
            this.engine.addEventListener('change', this.getSubModel.bind(this))
            this.submodel.addEventListener('change', this.finalSub.bind(this))

            this.formId = document.getElementById('the-forid')
            this.initMakeSearch()

        }
        getYear(evt){
            let selectMake = this.make.options[this.make.selectedIndex].value
            if( selectMake == 'select'){
                this.year.disabled = true
                this.model.disabled = true
                this.engine.disabled = true
                this.submodel.disabled = true
            }else{
                this.model.disabled = true
                this.engine.disabled = true
                this.submodel.disabled = true
                this.makeDone = selectMake
                this.urlPath = `/collections/NAMURA?filter.p.m.custom.bike_make=${this.makeDone}`
                this.formId.setAttribute("href", this.urlPath)
                axios.get(`collections/NAMURA?filter.p.m.custom.bike_make=${this.makeDone}&view=ajax`)
                    .then(
                        response => {
                            let parser = new DOMParser();
                            const dataParce = parser.parseFromString(response.data, 'text/html')
                            const dataParceTarget = dataParce.querySelector('.select-year-parts-result')

                            let newYearA = []
                            for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
                                if (dataParceTarget.options[i].value) newYearA.push(dataParceTarget.options[i].value);
                            }
                            let uniqueArray = newYearA.filter(function(item, pos, self) {
                                return self.indexOf(item) == pos;
                            })
                            var newYear = '<option value="' + 'select' + '">' + 'select' + '</option>'
                            uniqueArray.forEach(
                                option => {
                                    newYear += '<option value="' + option + '">' + option + '</option>';
                                }
                            )
                            this.year.innerHTML = newYear
                            this.year.disabled = false
                        }
                    )
                    .catch(function (error) {
                        console.log(error)
                    })
                    .finally(() => {
                        // you finaly code here
                    })


            }
        }

        getModel(evt){
            let selectYear = this.year.options[this.year.selectedIndex].value
            if( selectYear == 'select'){
                this.model.disabled = true
                this.engine.disabled = true
                this.submodel.disabled = true
            }else{
                this.engine.disabled = true
                this.submodel.disabled = true
                this.yearDone = selectYear
                this.urlPath = `/collections/NAMURA?filter.p.m.custom.bike_make=${this.makeDone}&filter.p.m.custom.year=${this.yearDone}`
                this.formId.setAttribute("href", this.urlPath)
                axios.get(`/collections/NAMURA?filter.p.m.custom.bike_make=${this.makeDone}&filter.p.m.custom.year=${this.yearDone}&view=ajax`)
                    .then(
                        response => {
                            let parser = new DOMParser();
                            const data = parser.parseFromString(response.data, 'text/html')
                            const dataParceTarget = data.querySelector('.select-model-parts-result')

                            let newModel = []
                            for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
                                if (dataParceTarget.options[i].value) newModel.push(dataParceTarget.options[i].value);
                            }
                            let uniqueArray = newModel.filter(function(item, pos, self) {
                                return self.indexOf(item) == pos;
                            })
                            var newModelRen = '<option value="' + 'select' + '">' + 'select' + '</option>'
                            uniqueArray.forEach(
                                option => {
                                    newModelRen += '<option value="' + option + '">' + option + '</option>';
                                }
                            )

                            this.model.innerHTML = newModelRen
                            this.model.disabled = false
                        }
                    )
                    .catch(function (error) {
                        console.log(error)
                    })
                    .finally(() => {
                        // you finaly code here
                    })
            }
        }

        getEng(evt){
            let selectModel = this.model.options[this.model.selectedIndex].value
            if( selectModel == 'select'){
                this.engine.disabled = true
                this.submodel.disabled = true
            }else{
                this.submodel.disabled = true
                this.modelDone = selectModel
                this.urlPath = `/collections/NAMURA?filter.p.m.custom.bike_make=${this.makeDone}&filter.p.m.custom.year=${this.yearDone}&filter.p.m.custom.model1=${this.modelDone}`
                this.formId.setAttribute("href", this.urlPath)
                axios.get(`/collections/NAMURA?filter.p.m.custom.bike_make=${this.makeDone}&filter.p.m.custom.year=${this.yearDone}&filter.p.m.custom.model1=${this.modelDone}&view=ajax`)
                    .then(
                        response => {
                            let parser = new DOMParser();
                            const data = parser.parseFromString(response.data, 'text/html')
                            const dataEng = data.querySelector('.select-engine-parts-result')


                            let newEng= []
                            for (var i=0, n=dataEng.options.length; i<n; i++) {
                                if (dataEng.options[i].value) newEng.push(dataEng.options[i].value);
                            }
                            let uniqueEng = newEng.filter(function(item, pos, self) {
                                return self.indexOf(item) == pos;
                            })
                            var newEngS = '<option value="' + 'select' + '">' + 'select' + '</option>'
                            uniqueEng.forEach(
                                option => {
                                    newEngS += '<option value="' + option + '">' + option + '</option>';
                                }
                            )
                            this.engine.innerHTML = newEngS
                            this.engine.disabled = false
                        }
                    )
                    .catch(function (error) {
                        console.log(error)
                    })
                    .finally(() => {
                        // you finaly code here
                    })
            }
        }

        getSubModel(evt){
            let selectEng = this.engine.options[this.engine.selectedIndex].value
            if( selectEng == 'select'){
                this.submodel.disabled = true
            }else{
                this.engineDone = selectEng
                this.urlPath = `/collections/NAMURA?filter.p.m.custom.bike_make=${this.makeDone}&filter.p.m.custom.year=${this.yearDone}&filter.p.m.custom.model1=${this.modelDone}&filter.p.m.custom.engine_capacity=${this.engineDone}`
                this.formId.setAttribute("href", this.urlPath)
                axios.get(`/collections/NAMURA?filter.p.m.custom.bike_make=${this.makeDone}&filter.p.m.custom.year=${this.yearDone}&filter.p.m.custom.model1=${this.modelDone}&filter.p.m.custom.engine_capacity=${this.engineDone}&view=ajax`)
                    .then(
                        response => {
                            let parser = new DOMParser();
                            const data = parser.parseFromString(response.data, 'text/html')

                            // class name
                            const dataParceTarget = data.querySelector('.select-sub-model-parts-result')

                            let subNewModel = []
                            for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
                                if (dataParceTarget.options[i].value) subNewModel.push(dataParceTarget.options[i].value);
                            }
                            let uniqueArray = subNewModel.filter(function(item, pos, self) {
                                return self.indexOf(item) == pos;
                            })
                            var subNewModelRe = '<option value="' + 'select' + '">' + 'select' + '</option>'
                            uniqueArray.forEach(
                                option => {
                                    subNewModelRe += '<option value="' + option + '">' + option + '</option>';
                                }
                            )
                            this.submodel.innerHTML = subNewModelRe
                            this.submodel.disabled = false
                        }
                    )
                    .catch(function (error) {
                        console.log(error)
                    })
                    .finally(() => {
                        // you finaly code here
                    })
            }
        }

        finalSub(evt){
            evt.preventDefault()
            let selectVal = this.submodel.options[this.submodel.selectedIndex].value
            if( selectVal != 'select'){
            }
        }

        initMakeSearch(){
            axios.get(`/collections/NAMURA?view=ajax`)
                .then(
                    response => {
                        let parser = new DOMParser();
                        const dataParce = parser.parseFromString(response.data, 'text/html')
                        const dataParceTarget = dataParce.querySelector('.select-make-parts-result')
                        let newMake = []

                        for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
                            if (dataParceTarget.options[i].value) newMake.push(dataParceTarget.options[i].value);
                        }

                        let uniqueArray = newMake.filter(function(item, pos, self) {
                            return self.indexOf(item) == pos;
                        })

                        var newMakeOp = '<option value="' + 'select' + '">' + 'select' + '</option>'
                        uniqueArray.forEach(
                            option => {
                                newMakeOp += '<option value="' + option + '">' + option + '</option>';
                            }
                        )
                        this.make.innerHTML = newMakeOp

                    }
                )
                .catch(function (error) {
                    console.log(error)
                })
                .finally(() => {
                    // you finaly code here
                })
        }
    })
}